import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { OrderDetailItemUi } from '@/components/Order/OrdersDetail/OrdersDetailUi';
import COLORS from '@/constants/colors';
import { DetailOrderResponse } from '@/data/api/model/orders/detailOrdersDto';
import { DeliveryDataResponse } from '@/data/api/model/orders/orderDetailsDto';
import { formatDollarAmount } from '@/utils/amounts';
import dayjs from 'dayjs';

export const detailOrderToDetailOrderItemUi = (
  item: DetailOrderResponse
): OrderDetailItemUi => {
  return {
    orderId: item.order_detail_id,
    orderNumber: item.order_detail_number,
    sellerName: item.seller_name,
    buyerName: item.business_name,
    kamOwner: item.kam_owner_name,
    deliveryWindow: formatDeliveryWindow(item.delivery),
    remission: item.remision ?? false,
    badgeStatus: getStatusBadge(item.status),
    total: `${formatDollarAmount(item.total_order_detail_amount)}`,
  };
};

function formatDeliveryWindow(delivery?: DeliveryDataResponse | null) {
  const { delivery_date, delivery_time, delivery_time_end } = delivery || {};
  if (!delivery_date || !delivery_time || !delivery_time_end) return '';
  const formattedDate = dayjs(delivery_date).format('DD/MM/YY');
  return `${formattedDate} (${delivery_time}-${delivery_time_end})`;
}

export function getStatusBadge(status?: string): statusBadgeUi {
  switch (status?.toLowerCase()) {
    case 'accepted':
      return {
        textColor: COLORS.blue_700,
        backgroundColor: COLORS.blue_50,
        edgeColor: COLORS.blue_200,
        text: 'Aceptado',
      };
    case 'created':
      return {
        textColor: COLORS.yellow_700,
        backgroundColor: COLORS.yellow_50,
        edgeColor: COLORS.yellow_200,
        text: 'Creado',
      };
    case 'pending':
      return {
        textColor: COLORS.yellow_700,
        backgroundColor: COLORS.yellow_50,
        edgeColor: COLORS.yellow_200,
        text: 'Pendiente',
      };
    case 'delivered':
      return {
        textColor: COLORS.success_700,
        backgroundColor: COLORS.success_50,
        edgeColor: COLORS.success_200,
        text: 'Entregado',
      };
    case 'canceled':
      return {
        textColor: COLORS.red_700,
        backgroundColor: COLORS.red_50,
        edgeColor: COLORS.red_200,
        text: 'Cancelado',
      };
    case 'rejected':
      return {
        textColor: COLORS.orange_800,
        backgroundColor: COLORS.orange_100,
        edgeColor: COLORS.orange_300,
        text: 'Rechazado',
      };
    default:
      return {
        textColor: COLORS.gray,
        backgroundColor: COLORS.light_gray,
        edgeColor: COLORS.dark_gray,
        text: 'Desconocido',
      };
  }
}
